"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrigin = void 0;
var getOrigin = function (siteUrl) {
    try {
        return new URL(siteUrl).origin;
    }
    catch (er) {
        var a = document.createElement('a');
        a.setAttribute('href', siteUrl);
        return "".concat(a.protocol, "//").concat(a.host);
    }
};
exports.getOrigin = getOrigin;
//# sourceMappingURL=get-origin.js.map